import { FC, ReactNode } from 'react';

import { Box, Flex, forwardRef, rem, StyleProps } from '@bonusly/design-system';

interface CountBadgeProps extends StyleProps {
	children: ReactNode;
	isUnread?: boolean;
	size?: number | string;
}

export const UnreadBadge: FC<CountBadgeProps> = forwardRef(({ children, isUnread = false, size = rem(8), ...rest }, ref) => (
	<Box display="inline-block" position="relative" ref={ref}>
		{children}
		{isUnread && (
			<Flex
				alignItems="center"
				bg="red.500"
				border="none"
				borderRadius="full"
				bottom="auto"
				color="white"
				fontSize="xs"
				fontWeight="semibold"
				h={size}
				justifyContent="center"
				position="absolute"
				left={rem(-4)}
				top={rem(-4)}
				w={size}
				{...rest}
			/>
		)}
	</Box>
));
